import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Logo } from './Logo';
import { MdClose } from 'react-icons/md';
import { Menu } from 'react-feather';
import { useAuth } from 'lib/auth';

const LinkItems = [
  {
    title: 'Home',
    link: '/',
  },
  {
    title: 'About Us',
    link: '/about-us',
  },
  // {
  //   title: 'Blog',
  //   link: '/blog',
  // },
  {
    title: 'Contact Us',
    link: '/contact-us',
  },
];

const LinkItem = ({ title, link }) => {
  return (
    <Link
      to={link}
      className="my-1 text-lg text-white font-medium hover:text-indigo-500 md:mx-4 md:my-0"
    >
      {title}
    </Link>
  );
};

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const { user } = useAuth();

  return (
    <nav className="bg-[#004454] px-3 md:px-48 py-2 shadow">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="flex justify-between space-x-48 items-center">
          <div>
            <Logo />
          </div>
          <div>
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="block text-gray-800 hover:text-gray-700 focus:text-gray-700 focus:outline-none md:hidden"
            >
              {isOpen ? (
                <MdClose className="h-6 w-6 fill-current" />
              ) : (
                <Menu className="h-6 w-6 fill-current" />
              )}
            </button>
          </div>
        </div>

        <div className={`md:flex items-center ${isOpen ? '' : 'hidden'}`}>
          <div className="flex flex-col items-center md:space-x-10 md:flex-row md:mx-6">
            {LinkItems.map((item, index) => (
              <LinkItem key={index} title={item.title} link={item.link} />
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};
